module.exports = __webpack_public_path__ + "static/media/EHS-Whistleblowing-Policy-and-Procedure.ce104605.pdf";